export type Coordinate = {
  lat: number;
  lng: number;
};

export const DEFAULT_START_LOCATION: Coordinate = {
  lat: 22.30214869702195,
  lng: 114.16716429776267,
};
export const DEFAULT_MAP_ID: number = -1;
export const DEFAULT_VENUE_ID: number = 149; // XIQU
